import React from "react";
import ReactPlayer from "react-player";

interface GalleryVideoPlayerProps {
  videoUrl: string;
  posterImg: string;
}

const Gallery__VideoPlayer: React.FC<GalleryVideoPlayerProps> = ({
  videoUrl,
  posterImg,
}) => {
  return (
    <>
      <ReactPlayer
        url={videoUrl}
        controls={true}
        playing={true}
        light={posterImg}
      />
    </>
  );
};

export default Gallery__VideoPlayer;
